import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Utils} from "../../../utils";
import {UiManagerService} from "../../../services/ui-manager.service";

export interface SkillDialogData {
  name: string;
  validityInDays?: number;
  color?: string;
}

@Component({
  selector: 'app-new-skill-dialog',
  templateUrl: './new-skill-dialog.component.html',
  styleUrls: ['./new-skill-dialog.component.scss']
})
export class NewSkillDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NewSkillDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SkillDialogData) {
    if (data.color == null) {
      data.color = UiManagerService.colors[4];
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

  validate() {
    return !Utils.isEmpty(this.data.name) && this.data.validityInDays >= 0;
  }

}
